<template>
              <div v-if="editable" class="full_width">
              <slot :error="validation.hasError('value')" :error-messages="validation.allErrors('value')" :label="label">
                <v-text-field
                              type="text"
                              :label="label"
                              :value="value"
                              @input="onInput"
                              :error="validation.hasError('value')"
                              :error-messages="validation.allErrors('value')"
                              v-bind="props"
                              :hint="description"
                              persistent-hint
                />
              </slot>
              </div>
</template>

<script>
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'

export default {
  validators: {
    'value': function (value) {
      value = value || null
      return Validator.value(value).custom(serverValidation(this.formErrors, this.field))
    }
  },
  props: {
    props: {
      type: Object,
      default: function () {
        return {}
      }
    },
    value: {},
    objValue: {},
    label: {type: String},
    description: {type: String},
    editable: {type: Boolean},
    field: {type: String},
    placeholder: {type: String},
    inputId: {type: String},
    formErrors: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    'formErrors': function (oldVar, newVar) {
      this.$validate()
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style>
.full_width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerStepField.vue